import React, { FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import { ButtonRegular } from '../ui/Button'
import { colors } from '../styles/colors'
import VoteIoSuccess from '../svgr/VoteIoSuccess'
import { DialogCloseButton } from '../components/DialogCloseButton'

export const BoxCreatedSuccessDialog: FC<{
  onViewMyBoxes: () => void
  onShareBox: () => void
  onClose?: () => void
}> = ({
  onViewMyBoxes,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onShareBox,
  onClose,
}) => {
  return (
    <DialogContainer>
      {onClose && <DialogCloseButton onClick={onClose} />}

      <IconContainer>
        <VoteIoSuccess />
      </IconContainer>

      <ContentContainer>
        <TitleContainer>
          <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
            <FormattedMessage
              id="dialog.boxCreatedSuccess.title"
              defaultMessage="Бокс успешно создан"
            />
          </Typography>
        </TitleContainer>

        <DescriptionContainer>
          <Typography
            fontSize={14}
            fontWeight={400}
            color={colors.secondary}
            font="roboto"
          >
            <FormattedMessage
              id="dialog.boxCreatedSuccess.description"
              defaultMessage="Вы можете поделиться им своим друзьям или создать еще один бокс"
            />
          </Typography>
        </DescriptionContainer>
      </ContentContainer>

      <ButtonsContainer>
        <PrimaryButton
          onClick={onViewMyBoxes}
          textColor={colors.white}
          textWeight={700}
        >
          <FormattedMessage
            id="dialog.boxCreatedSuccess.viewMyBoxes"
            defaultMessage="Все мои боксы"
          />
        </PrimaryButton>
      </ButtonsContainer>
    </DialogContainer>
  )
}

export const boxCreatedSuccessDialogPath = '/box-created-success-dialog'

const DialogContainer = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  gap: 48px;
  background: ${colors.bgPrimary};
  border-radius: 20px;
  padding: 48px 32px;
  width: 100%;
  max-width: 400px;
  text-align: center;
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 120px;
    height: auto;
  }
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`

const ButtonsContainer = styled.div`
  width: 100%;
  max-width: 280px;
  display: grid;
  gap: 12px;
`

const PrimaryButton = styled(ButtonRegular)`
  width: 100%;
  background: ${colors.secondary};
  color: ${colors.white};
`

const SecondaryButton = styled(ButtonRegular)`
  width: 100%;
  background: transparent;
  border: 1px solid ${colors.borderPrimary};
  color: ${colors.textPrimary};
`
